import { Row, Col, Image } from 'antd';
import { useStepUpdateContext } from '../../contexts/step_context';
import { useAnswersUpdateContext } from '../../contexts/answers_context';
import noImage from '../../images/no.svg'
import bankruptcyImage from '../../images/bankruptcy.svg'
import foreclosureImage from '../../images/foreclosure.svg'
import BackButton from '../common/back_button';
import bothImage from '../../images/both.svg'
import './styles.css';
import { Typography } from 'antd';
const { Title, Text } = Typography;


function CommunicationMethod() {
    const stepUpdate = useStepUpdateContext();
    const answersUpdate = useAnswersUpdateContext();
    const question = 'communication_method'
    
    const handleNextPageClick = (answer) => {
        answersUpdate(question, answer)
        stepUpdate()
    }

    return (
        <>
            <Row style={{paddingBottom: 30}}>
                <Col span={24} style={{ textAlign: 'center', verticalAlign: 'center' }}>
                    <BackButton />
                </Col>
                <Col span={24} style={{ textAlign: 'center' }}>
                    <Title>Thank you for your submission. What is your preferred contact method?</Title>
                </Col>
            </Row>
            <Row justify="center" gutter={16}>
                <Col span={4} className="card" onClick={() => handleNextPageClick('phone')}>
                    <Row justify="center">
                        <Col>
                            <Image 
                                src={noImage}
                                width={95}
                                height={95}
                                alt=''
                                preview={false}
                            />
                        </Col>
                    </Row>
                    <Row justify="center">
                        <Col>
                            <h1>Phone</h1>
                        </Col>
                    </Row>
                </Col>
                <Col span={4} className="card" style={{marginLeft: 20}} onClick={() => handleNextPageClick('online')}>
                    <Row justify="center">
                        <Col>
                            <Image 
                                src={bankruptcyImage}
                                height={95}
                                width={95}
                                alt=''
                                preview={false}
                            />
                        </Col>
                    </Row>
                    <Row justify="center">
                        <Col>
                            <h1>Email</h1>
                        </Col>
                    </Row>
                </Col>
                <Col span={4} className="card" style={{marginLeft: 20}} onClick={() => handleNextPageClick('any')}>
                    <Row justify="center">
                        <Col>
                            <Image 
                                src={foreclosureImage}
                                width={95}
                                height={95}
                                alt=''
                                preview={false}
                            />
                        </Col>
                    </Row>
                    <Row justify="center">
                        <Col>
                            <h1>No Preference</h1>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <br />
            <Row style={{padding: 30}}>
                <Col span={24} style={{ textAlign: 'center' }}>
                    <p>By clicking the button above, you authorize companies on this list to call and send sms messages to the phone # above using an autodialer even if your phone number is on any do not call list. Your consent here is not based on a condition of purchase. You may revoke your consent at anytime or contact us at info@usamortgagesurvey.com</p>
                </Col>
            </Row>
        </>
    );
}

export default CommunicationMethod;